import PropTypes from 'prop-types';
import styled from 'styled-components';
import AccountRow from './AccountRow';
import FrontendPagination from '../../lib/FrontendPagination';
import Account from '../models/Account';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FixedWidthNameCol = styled.col.withConfig({
  displayName: "AccountTable__FixedWidthNameCol",
  componentId: "sc-1y88e29-0"
})(["width:350px;"]);
const FixedWidthDetailsCol = styled.col.withConfig({
  displayName: "AccountTable__FixedWidthDetailsCol",
  componentId: "sc-1y88e29-1"
})(["width:275px;"]);
const FixedWidthDiv = styled.div.withConfig({
  displayName: "AccountTable__FixedWidthDiv",
  componentId: "sc-1y88e29-2"
})(["position:relative;width:625px;display:table-cell;"]);
const AccountTable = ({
  accountsPagination,
  selectedAccount,
  setSelectedAccount
}) => {
  if (accountsPagination.getVisible().size === 0) {
    return /*#__PURE__*/_jsx(FixedWidthDiv, {
      children: /*#__PURE__*/_jsx(UIResultsMessage, {
        illustration: "empty-state-charts",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-experience-shared-components.accountPicker.table.empty"
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(UITable, {
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx(FixedWidthNameCol, {}), /*#__PURE__*/_jsx(FixedWidthDetailsCol, {}), /*#__PURE__*/_jsx("col", {})]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-experience-shared-components.accountPicker.table.name"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-experience-shared-components.accountPicker.table.details"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: accountsPagination.getVisible().map(account => {
        return /*#__PURE__*/_jsx(AccountRow, {
          account: account,
          selectedAccount: selectedAccount,
          setSelectedAccount: setSelectedAccount
        }, account.get('id'));
      })
    })]
  });
};
AccountTable.propTypes = {
  accountsPagination: PropTypes.instanceOf(FrontendPagination).isRequired,
  setSelectedAccount: PropTypes.func.isRequired,
  selectedAccount: PropTypes.instanceOf(Account)
};
export default AccountTable;